import React from 'react'
import './footer.css'
import {Link, useLocation} from "react-router-dom"

const Footer = ({setActiveNav}) => {
    let locationLength = useLocation().pathname.split('/').length
    const brand = (
        <>
            <span className="brand_mark footer_brand_mark" aria-hidden="true"><span>Y</span></span>
            <span className="brand_words footer_brand_words">
                <span className="brand_name"><span>ArtDesign</span> <em>Yana</em></span>
                <small>Interior sketches & visualisation</small>
            </span>
        </>
    )

    return (
        <footer>
            {locationLength === 2
                ? <a href='#header' onClick={() => setActiveNav('#')} className='footer_logo'>{brand}</a>
                : <Link to='/' onClick={() => setActiveNav('#')} className='footer_logo'>{brand}</Link>
            }
            <div className='footer_copyright'>
                <small>&copy; ArtDesign Yana</small>
            </div>
        </footer>
    );
};

export default Footer;
